export const UPLOAD_IMAGE = 'MEDIA_LIBRARY.UPLOAD_IMAGE';
export const UPLOAD_IMAGE_START = 'MEDIA_LIBRARY.UPLOAD_IMAGE_START';
export const UPLOAD_IMAGE_FAIL = 'MEDIA_LIBRARY.UPLOAD_IMAGE_FAIL';
export const UPLOAD_IMAGE_SUCCESS = 'MEDIA_LIBRARY.UPLOAD_IMAGE_SUCCESS';

export const GET_UPLOADS = 'MEDIA_LIBRARY.GET_UPLOADS';
export const GET_UPLOADS_START = 'MEDIA_LIBRARY.GET_UPLOADS_START';
export const GET_UPLOADS_FAIL = 'MEDIA_LIBRARY.GET_UPLOADS_FAIL';
export const GET_UPLOADS_SUCCESS = 'MEDIA_LIBRARY.GET_UPLOADS_SUCCESS';
